import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { DtpPanel } from 'dtp-react-components';
import { Grid, SimpleGrid } from '../../../components/index';
import * as listUtils from '../../../utils/listsSelect';
import { formatarValor, formatarCnpj } from '../../../utils/helpers';

class InfoPagamento extends React.Component {
  getTagStatus() {
    const listaEstados = listUtils.estadosPagamento;
    if (this.props.estadoFormulario.infoPagamento.idControlePagamento) {
      let estadoCss = '';
      switch (this.props.estadoFormulario.infoPagamento.estado) {
        case 1:
          estadoCss = 'estadoAberto';
          break;
        case 2:
          estadoCss = 'estadoEmProcessamento';
          break;
        case 3:
          estadoCss = 'estadoContestado';
          break;
        case 4:
          estadoCss = 'estadoAguardandoAnaliseDefesa';
          break;
        case 5:
          estadoCss = 'estadoPago';
          break;
        case 6:
          estadoCss = 'estadoRejeitado';
          break;
        case 7:
          estadoCss = 'estadoNaoPago';
          break;
        case 8:
          estadoCss = 'estadoNaoMonitorado';
          break;
        case 9:
          estadoCss = 'estadoEmAnaliseDefesaRegularidadePagamento';
          break;
        case 10:
          estadoCss = 'estadoEmAnaliseDefesaGru';
          break;
        case 11:
          estadoCss = 'estadoEmAnaliseDefesaExtraordinaria';
          break;
        case 12:
          estadoCss = 'estadoContestacaoExtraordinaria';
          break;
        default: estadoCss = '';
      }

      return (
        <div
          className={estadoCss}
          style={{
            textAlign: 'center',
            fontSize: '12px',
            maxWidth: 'inherit',
            padding: '5px 7px 5px 7px',
            minHeight: 'inherit',
          }}
        >
          {listUtils.getObject(listaEstados, this.props.estadoFormulario.infoPagamento.estado).label}
        </div>
      );
    }
    return (<div>.</div>);
  }

  textoDestaque = texto => (
    (<span style={{ fontWeight: '600' }}>{texto}</span>)
  )

// formatarValor = (valor) => {
//   let valorFormatado = '0.0';
//   if ((valor !== undefined) && (valor !== null)) {
//     const formato = {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 3,
//       style: 'currency',
//       currency: 'BRL',
//     };
//     if (valor === 0 || valor === '') {
//       return 'R$ 0,00';
//     }
//     valorFormatado = valor.toLocaleString('pt-BR', formato);
//   }
//   return valorFormatado;
// };

formatarCompetencia = (mes, ano) => {
  let objCompetencia = `${mes}/${ano}`;
  if (objCompetencia.length !== 7) {
    objCompetencia = `0${objCompetencia}`;
  }
  return objCompetencia;
};

render() {
  const rowStyle = {
    marginBottom: '10px',
    fontSize: '16px',
  };

  return (
    <DtpPanel title="Informações do Pagamento">
      <div style={{ float: 'right' }}>{this.getTagStatus()}</div>
      <div className="row" style={rowStyle}>
        <SimpleGrid>
          <Grid cols="12 12 12 12">
            <span>{this.textoDestaque('Pagador: ')}  {this.props.estadoFormulario.infoPagamento.nomeEntidadePagadora}</span>
          </Grid>
        </SimpleGrid>
      </div>
      <div className="row" style={rowStyle}>
        <SimpleGrid>
          <Grid cols="5 5 5 5">
            <span>{this.textoDestaque('Recebedor: ')}  {this.props.estadoFormulario.infoPagamento.nomeEntidadeRecebedora}</span>
          </Grid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Prazo Resposta: ')}  {this.props.estadoFormulario.infoPagamento.dataPrazo} </span>
          </Grid>
        </SimpleGrid>
      </div>
      <div className="row" style={rowStyle}>
        <SimpleGrid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Banco: ')}
              {`${this.props.estadoFormulario.infoPagamento.codigoBanco} - ${this.props.estadoFormulario.infoPagamento.nomeBanco}`}
            </span>
          </Grid>
          <Grid cols="2 2 2 2">
            <span>{this.textoDestaque('Agência: ')}
              {`${this.props.estadoFormulario.infoPagamento.numeroAgencia} - ${this.props.estadoFormulario.infoPagamento.dvAgencia}`}
            </span>
          </Grid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Conta corrente: ')}
              {`${this.props.estadoFormulario.infoPagamento.numeroContaCorrente} - ${this.props.estadoFormulario.infoPagamento.dvContaCorrente}`}
            </span>
          </Grid>
          <Grid cols="4 4 4 4">
            <span>{this.textoDestaque('CNPJ RPPS: ')}  {formatarCnpj(this.props.estadoFormulario.infoPagamento.cnpj)}</span>
          </Grid>
        </SimpleGrid>
      </div>
      <div className="row" style={rowStyle}>
        <SimpleGrid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Competência: ')}
              {this.formatarCompetencia(this.props.estadoFormulario.infoPagamento.mes, this.props.estadoFormulario.infoPagamento.ano)}
            </span>
          </Grid>
          <Grid cols="2 2 2 2">
            <span>{this.textoDestaque('Valor: ')}  {formatarValor(this.props.estadoFormulario.infoPagamento.valorCompensacao)}</span>
          </Grid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Vencimento: ')}  {this.props.estadoFormulario.infoPagamento.dataVencimento} </span>
          </Grid>
        </SimpleGrid>
      </div>
      {this.props.estadoFormulario.infoPagamento.dataPagamentoAtraso &&
        <Fragment>
          <div style={rowStyle}>
            <h3 className="dtp-datagrid-header" style={{ fontSize: '18px' }}>Pagamento em atraso</h3>
          </div>
          <SimpleGrid>
            <div style={rowStyle}>
              <Grid cols="3 3 3 3">
                <span>{this.textoDestaque('Data do pagamento: ')}  {this.props.estadoFormulario.infoPagamento.dataPagamentoAtraso}</span>
              </Grid>
              <Grid cols="3 3 3 3">
                <span>{this.textoDestaque('Multa: ')}  {formatarValor(this.props.estadoFormulario.infoPagamento.valorMulta)}</span>
              </Grid>
              <Grid cols="3 3 3 3">
                <span>{this.textoDestaque('Juros: ')}  {formatarValor(this.props.estadoFormulario.infoPagamento.valorJuros)} </span>
              </Grid>
              <Grid cols="3 3 3 3">
                <span>
                  {this.textoDestaque('Valor total: ')} {formatarValor(this.props.estadoFormulario.infoPagamento.valorCompensacao +
                  this.props.estadoFormulario.infoPagamento.valorMulta +
                  this.props.estadoFormulario.infoPagamento.valorJuros)}
                </span>
              </Grid>
            </div>
          </SimpleGrid>
        </Fragment>
      }
    </DtpPanel>
  );
}
}

InfoPagamento.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default InfoPagamento;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/InfoPagamento.jsx